import { combineReducers } from "redux";

import { queuesEntriesReducer } from "modules/Queues/services/Queues/reducer";

export const queuesReducer = combineReducers({ entries: queuesEntriesReducer });